import ui from 'boxjs/dist/components/ui/index';
export const {open, close, update} = ui;
export default ui;
